<template>
    <v-carousel
        v-model="step"
        :show-arrows="false"
        :continuous="false"
        hide-delimiters
        hide-delimiter-background
        height="auto"
    >
        <v-carousel-item>
        <v-card class="py-3">
            <v-card-text class="pt-0 pb-0 cardtext">
                <div class="container my-4">
                    <v-row>
                        <v-col class="py-0">
                            <p class="my-0 subtitle-1 font-weight-bold">
                                Exchange Rate
                            </p>
                        </v-col>
                        <v-col class="text-right py-0">
                            <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                                1 {{ order.matcher_currency}} = {{ exchangeRate.toFixed(5) }} {{ order.poster_currency }}
                            </p>
                        </v-col>
                    </v-row>
                </div>
                <v-form data-vv-scope="amount-form">
                    <v-text-field
                        v-model="youSend"
                        outlined
                        label="You send"
                        name="you_send"
                        v-validate="`required|min_value:1`"
                        :suffix="order.matcher_currency"
                        :error-messages="errors.first('amount-form.you_send')"
                    />
                    <v-text-field
                        v-model="recipientGets"
                        outlined
                        label="Recipient Gets"
                        name="recipient_gets"
                        v-validate="`required|min_value:1`"
                        :suffix="order.poster_currency"
                        :error-messages="errors.first('amount-form.recipient_gets')"
                    />
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer/>
                <v-btn
                    v-if="amount"
                    class="px-6"
                    color="primary"
                    dark
                    depressed
                    large
                    :disabled="!amount"
                    @click="$emit('update:step', 1)"
                >
                    Next
                </v-btn>
            </v-card-actions>
        </v-card>
            </v-carousel-item>
            <v-carousel-item>
        <v-card class="py-3">
            <v-card-text class="pt-4 pb-0 cardtext">

                <v-autocomplete
                    :value="recipient"
                    @input="onRecipientSelected"
                    name="select-recipient"
                    label="Select Recipient"
                    :items="recipients"
                    item-text="recipient_info.name"
                    item-value="id"
                    return-object
                    item-color="primary"
                    color="primary"
                    outlined
                    clearable
                />

                <p>Or create new one</p>

                <v-form
                    id="recipient-details"
                    data-vv-scope="recipient-details"
                >
                    <v-text-field
                        v-model="recipient.recipient_info.phone"
                        name="phone"
                        label="Phone number"
                        color="primary"
                        v-validate="phoneRules"
                        validate-on-blur
                        :error-messages="errors.first('recipient-details.phone')"
                        outlined
                    />

                    <v-text-field
                        v-model="recipient.recipient_info.city"
                        name="city"
                        label="City"
                        color="primary"
                        v-validate="'required'"
                        validate-on-blur
                        :error-messages="errors.first('recipient-details.city')"
                        outlined
                    />

                    <v-select
                        v-model="recipient.recipient_info.bank_code"
                        :items="banks"
                        :item-text="'Name'"
                        :item-value="'Code'"
                        :label="'Bank'"
                        name="bank_code"
                        color="primary"
                        v-validate="'required'"
                        :error-messages="errors.first('recipient-details.bank_code')"
                        outlined
                        :disabled="verifyingAccount"
                    ></v-select>

                    <v-text-field
                        v-model="recipient.recipient_info.account_number"
                        type="text"
                        label="Account number"
                        name="account_number"
                        color="primary"
                        v-validate="'required'"
                        :error-messages="errors.first('recipient-details.account_number')"
                        outlined
                        :disabled="verifyingAccount"
                        :loading="verifyingAccount"
                    />

                    <p class="title green--text font-weight-bold mb-7 text-center">
                        {{ recipient.recipient_info.name }}
                    </p>

                    <v-alert
                        v-if="accountVerificationError"
                        type="error"
                        outlined
                        text
                    >
                        Failed to resolve the name
                    </v-alert>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    class="px-6"
                    text
                    large
                    @click="$emit('update:step', 0)"
                >
                    Back
                </v-btn>
                <v-spacer/>
                <v-btn
                    class="px-6"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="confirmRecipient"
                    :disabled="verifyingAccount"
                >
                    Next
                </v-btn>
            </v-card-actions>
        </v-card>
            </v-carousel-item>
            <v-carousel-item>

        <v-card class="py-3">
            <v-card-text class="pt-4 pb-0 cardtext">

                <v-sheet
                    tile
                    color="#f9f9f9"
                    class="px-5 rounded-lg pt-4"
                >
                    <v-row>
                        <v-col class="pb-0">
                            <p class="my-0">You send</p>
                            <p class="body-1 my-0 font-weight-bold mb-0">
                                {{ getCurrencySymbol(order.matcher_currency) }}{{ youSend }}
                            </p>
                        </v-col>
                        <v-col cols="2" class="pb-0 pr-0">
                            <p class="title my-0 mt-2 primary--text">To</p>
                        </v-col>
                        <v-col class="text-right">
                            <p class="my-0">The Recipient</p>
                            <p class="body-1 font-weight-bold mb-0">{{ recipient.recipient_info.name }}</p>
                        </v-col>
                    </v-row>
                </v-sheet>

                <div class="px-1 pt-10 mt-8">
                    <v-row v-if="order.fakeFee">
                        <v-col class="py-0">
                            <p class="my-0 subtitle-1 text-capitalize">{{ order.matcher_payment_provider }} Fee</p>
                        </v-col>
                        <v-col class="text-right py-0">
                            <p class="body-1 subtitle-1 my-0 font-weight-bold">
                                {{ getCurrencySymbol(order.matcher_currency) }}{{ order.fakeFee }}
                            </p>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-divider class="ml-0" inset></v-divider>
                        </v-col>
                        <v-col class="py-0">
                            <p class="my-0 subtitle-1 font-weight-bold">Total</p>
                        </v-col>
                        <v-col class="text-right py-0">
                            <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                                {{ getCurrencySymbol(order.matcher_currency) }}{{ (youSend + order.fakeFee).toFixed(2) }}
                            </p>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col class="py-0">
                            <p class="my-0 subtitle-1 font-weight-bold">
                                Exchange Rate
                            </p>
                        </v-col>
                        <v-col class="text-right py-0">
                            <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                                {{ (exchangeRate).toFixed(3) }}
                                {{ order.poster_currency }} / {{ order.matcher_currency }}
                            </p>
                        </v-col>
                    </v-row>

                    <v-row v-if="recipientGets">
                        <v-col class="pt-0">
                            <p class="my-0 subtitle-1 font-weight-bold">
                                Recipient receives
                            </p>
                        </v-col>
                        <v-col class="text-right py-0">
                            <p class="body-1 subtitle-1 flex-grow-0 mb-0 font-weight-bold">
                                {{ recipientGets.toFixed(2) }} {{ order.poster_currency }}
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    v-if="!thirdPartyOrder"
                    class="px-6"
                    text
                    large
                    @click="$emit('update:step', 1)"
                >
                    Back
                </v-btn>
                <v-spacer/>
                <v-btn
                    v-if="!thirdPartyOrder"
                    class="px-6"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="confirm"
                >
                    Confirm
                </v-btn>
                <v-btn
                    v-if="thirdPartyOrder"
                    class="px-6"
                    color="primary"
                    dark
                    depressed
                    large
                    @click="pay"
                >
                    Pay
                </v-btn>
            </v-card-actions>
        </v-card>
            </v-carousel-item>
    </v-carousel>
</template>

<script>
let currency = require('../../../modules/currency.js');
import FlutterwaveService from '../../../services/FlutterwaveService';

const defaultRecipient = {
    recipient_info: {
        phone: null,
        city: null,
        bank_code: null,
        account_number: null,
        name: null,
    }
}

export default {
    props: {
        step: {
            type: Number,
            default: 0,
        },
        order: {
            type: Object,
            default: () => null,
        },
    },
    data() {
        return {
            banks: [],
            amount: null,
            recipient: defaultRecipient,
            recipients: [],
            verifyAccountTimeout: null,
            verifyingAccount: false,
            accountVerificationError: false,
            thirdPartyOrder: null,
            unifiedWidgetPayload: null,
        };
    },
    watch: {
        order: {
            deep: true,
            handler(order) {
                this.loadBanks(order.poster_country);
            }
        },
        'recipient.recipient_info.account_number': 'verifyAccountDebounced',
        'recipient.recipient_info.bank_code': 'verifyAccountDebounced',
    },
    async mounted () {
        await this.loadBanks(this.order.poster_country);
        await this.getRecipients()
    },
    computed: {
        exchangeRate() {
            if (!this.order) {
                return null
            }

            return this.order.exchange_rate;
        },
        youSend: {
            get() {
                if (!this.order) {
                    return null
                }

                return this.round(this.amount / this.exchangeRate);
            },
            set(v) {
                this.amount = this.round(v * this.exchangeRate)
            },
        },
        recipientGets: {
            get() {
                if (!this.order) {
                    return null
                }

                return this.round(this.amount);
            },
            set(v) {
                this.amount = this.round(v);
            },
        },
        phoneRules() {
            const countryCode = 'Nigeria'; // this.order.poster_country;
            return `required|country-code:${countryCode}|international-phone:${countryCode}`;
        }
    },
    methods: {
        getCurrencySymbol(currency_code) {
            return currency.getCurrencySymbol(currency_code);
        },
        round(x, d = 100) {
            return Math.round(x * d) / d;
        },
        async getRecipients() {
            this.$emit('loading')

            try {
                const { data } = await Vue.backendApi()
                    .user(this.$store.state.user.id)
                    .recipient()
                    .listRecipients({
                        country: this.order.poster_country,
                    })

                this.recipients = data.filter(({ recipient_type: t }) => t === 'bank-transfer')
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error fetching recipients',
                    text: err,
                });
            } finally {
                this.$emit('loaded')
            }
        },
        async updateRecipient(inputPayload) {
            this.$emit('loading')

            const { id } = inputPayload

            const payload = {
                recipient_info: inputPayload.recipient_info,
                user_id: inputPayload.user_id,
                country: inputPayload.country,
                institution_name: inputPayload.institution_name,
                recipient_type: 'bank-transfer',
            }

            try {
                await Vue.backendApi().user(this.$store.state.user.id)
                    .recipient(id)
                    .storeRecipient(payload)
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error updating recipient',
                    text: err,
                });
                throw err
            } finally {
                this.$emit('loaded')
            }
        },
        async createRecipient(inputPayload) {
            this.$emit('loading')

            const userId = this.$store.state.user.id;

            const payload = {
                ...inputPayload,
                user_id: userId,
                country: this.order.poster_country,
                recipient_type: 'bank-transfer',
            }

            const bank = this.banks.find((b) => b.Code === inputPayload.recipient_info.bank_code)
            if (bank) {
                payload.recipient_info.bank = bank
                payload.institution_name = bank.Name
            }

            try {
                await Vue.backendApi().user(userId)
                    .recipient().storeRecipient(payload)
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error updating recipient',
                    text: err,
                });
                throw err
            } finally {
                this.$emit('loaded')
            }
        },
        async loadBanks(abbreviation) {
            this.$emit('loading')

            try {
                const banks = await FlutterwaveService.getBanksByCountry(abbreviation)
                if (banks.length === 0) {
                    this.$swal({
                        type: 'error',
                        title: 'No banks found',
                    });
                } else {
                    this.banks = banks
                }
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error loading banks',
                });
            } finally {
                this.$emit('loaded');
            }
        },
        async verifyAccountDebounced () {
            if (this.verifyAccountTimeout) {
                clearTimeout(this.verifyAccountTimeout)
            }

            this.verifyAccountTimeout = setTimeout(() => {
               this.verifyAccount()
            }, 1000);
        },
        async verifyAccount () {
            if (this.verifyingAccount) return

            if (!this.recipient) return

            const {
                account_number,
                bank_code
            } = this.recipient.recipient_info;

            if (!account_number || !bank_code) return

            try {
                this.verifyingAccount = true
                this.recipient.recipient_info.name = null
                this.accountVerificationError = false

                const { data } = await FlutterwaveService.verifyAccount(account_number, bank_code);
                this.recipient.recipient_info.name = data.data.accountname;

                if (!this.recipient.recipient_info.name) {
                    this.accountVerificationError = true
                }
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Failed to verify account number',
                    text: err,
                });
            } finally {
                this.verifyingAccount = false
            }
        },
        onRecipientSelected (v) {
            if (v) {
                this.recipient = {
                    ...v,
                }
            } else {
                this.recipient = defaultRecipient
            }
        },
        async confirmRecipient() {
            const result = await this.$validator.validateAll('recipient-details');

            if (!result) return

            if (!this.recipient.recipient_info.name) {
                this.accountVerificationError = true
                return
            }

            if (this.recipient.id) {
                await this.updateRecipient(this.recipient)
            } else {
                await this.createRecipient(this.recipient)
            }

            this.$emit('update:step', 2)
        },
        async initiate3poUnifiedPayment () {
            const {
                matcher_payment_provider: service
            } = this.order;

            try {
                this.$emit('loading')
                await this.waitForUnifiedPay()
                this.$emit('loaded')

                window.UnifiedPay.unmount()
                window.UnifiedPay.mount(null, {
                    ...this.unifiedWidgetPayload,
                    skipMerchantScreen: true,
                    service,
                    token: process.env.MIX_UNIFIED_API_TOKEN,
                    onTransactionSuccess: () => {
                        this.$router.push({
                            name: 'transfers',
                        });
                    },
                    onError: async (type, error) => {
                        const { response } = error;

                        if (response && response.status === 500) {
                            this.$nextTick(() => {
                                window.UnifiedPay.unmount();
                            });

                            const { value: payManually } = await this.$swal({
                                type: 'error',
                                title: `Error initiating payment.
                                    Please try again or proceed manually.`,
                                showCancelButton: true,
                                showConfirmButton: true,
                                confirmButtonText: 'Pay manually',
                                cancelButtonText: 'Close and Retry',
                            });

                            if (payManually) {
                                this.initiateDefaultPayment()
                            } else {
                                this.initiate3poUnifiedPayment()
                            }
                        }
                    }
                });

                window.UnifiedPay.open()
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error initiating payment',
                    text: err,
                });
            }
        },
        initiateDefaultPayment () {
            if (!this.thirdPartyOrder) return

            this.$emit('initiateManualPayment', this.thirdPartyOrder)
        },
        async confirm () {
            const storePayload = {
                ...this.order,
                poster_amount: this.amount,
                matcher_amount: this.amount /this.order.exchange_rate,
                recipient: this.recipient,
            };

            // clean payload
            const unwantedProperties = [
                'type',
                'duration_object',
                'matcher_payment_method_type',
                'time',
                'id',
                'fakeFee',
                'company_slug',
                'eer',
                'key',
                'matcher_payment_provider',
            ];

            unwantedProperties.forEach((prop) => delete storePayload[prop]);

            this.$emit('loading')
            try {
                const response = await Vue.backendApi()
                .thirdPartyOrders()
                .storeOrder(storePayload);

                const { thirdPartyOrder, unifiedWidgetPayload } = response.data;
                this.thirdPartyOrder = thirdPartyOrder;
                this.unifiedWidgetPayload = unifiedWidgetPayload;

                this.pay()
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error storing third party offer',
                    text: err,
                });
            } finally {
                this.$emit('loaded')
            }
        },
        pay() {
            if (this.unifiedWidgetPayload) {
                return this.initiate3poUnifiedPayment();
            }

            this.initiateDefaultPayment()
        },
    },
};
</script>

<style scoped>
.cardtext {
    min-height: 50vh;
}
</style>
